import axios from 'axios'
import { Response, SnaphotReference, Snapshot } from '@/models'
import { ISnapshotService } from '@/services/ISnapshotService'
import ConfigConstants from '@/constants/Config.constants'

export default class SnapshotService implements ISnapshotService {
  private readonly options = {
    headers: {
      'content-type': ConfigConstants.CONTENT_TYPES.YT_V1,
      Accept: '*/*',
    },
  } as const

  constructor(private url: string) {
    //
  }

  public async getSnapshot(
    projectId: number,
    snapshotId: SnaphotReference,
  ): Promise<Response<Snapshot>> {
    return axios
      .get<Response<Snapshot>>(
        `${this.url}/project/${projectId}/snapshots/${snapshotId}`,
        this.options,
      )
      .then((response) => response.data)
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          throw new Error('Snapshot not found')
        }
        throw error
      })
  }

  public async getSnapshots(
    projectId: number,
    page?: number,
    pageSize?: number,
  ): Promise<Response<Snapshot[]>> {
    const params: Record<string, any> = {}

    if (page !== undefined) {
      params.page = page
    }

    if (pageSize !== undefined) {
      params.pageSize = pageSize
    }
    return axios
      .get<Response<Snapshot[]>>(`${this.url}/project/${projectId}/snapshots`, {
        ...this.options,
        params,
      })
      .then((response) => response.data)
  }

  sortSnapshots(snapshots: Snapshot[]): Snapshot[] {
    return [...snapshots].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
  }

  async deleteSnapshot(projectId: number, snapshot: Snapshot): Promise<Response<Snapshot>> {
    return axios
      .delete<
        Response<Snapshot>
      >(`${this.url}/project/${projectId}/snapshots/${snapshot.id}`, this.options)
      .then((response) => response.data)
  }
}
